module.exports = __webpack_public_path__ + "4f710ae6a215dbc25d7fe06d1e0f5a61.png";